import React, { FC, useState } from 'react';
import { Button, Paper } from '@mui/material';

import { useTranslate } from 'src/shared/providers';

import { EditPasswordModal } from './EditPasswordModal';

export const EditPasswordSection: FC = () => {
  const { t } = useTranslate();
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Paper id="edit-password-card" className="h-100 p-4">
      <div className="mb-3">
        <h4 className="pb-0 mb-0">{t('settings.changePassword')}</h4>
        <label className="text-muted d-block">{t('settings.youWillBeAbleToChangeYourPasswordInThisSection')}</label>
      </div>
      <Button id="change-password" className="mt-2" variant="contained" color="primary" onClick={() => setOpen(true)}>
        {t('settings.changePassword')}
      </Button>
      <EditPasswordModal open={open} onClose={() => setOpen(false)} />
    </Paper>
  );
};
